import React from 'react';
import QuestionnaireEvaluation from '../../components/questionnaire-evaluation';

const CompleteAction = ({
  viewer: {
    advisor,
    consultPath,
    products,
    borrower: { name, email },
    loan: { loanState },
    ...viewer
  },
  actionPipe,
  ...props
}) => {
  return (
    <QuestionnaireEvaluation
      scenario={'Affordability'}
      consultPath={consultPath}
      products={products}
      advisor={advisor}
      name={name}
      email={email}
      state={loanState}
      purpose={'affordability'}
      viewer={viewer}
      actionPipe={actionPipe}
      reviewItems={[
        'Basics of your financial profile',
        'How much home you can afford',
        'Your personalized affordability tool'
      ]}
      steps={[
        'Submit Your Information',
        'Schedule\u00A0a Review Call',
        'Receive Your Affordability Analysis'
      ]}
      {...props}
    />
  );
};

export default CompleteAction;



// WEBPACK FOOTER //
// ./src/products/affordability/dashboard.js